import request from '@/utils/request';
import { Role, IUser, IUserEdit } from './types';
import { AxiosPromise, AxiosResponse } from 'axios';
import _omit from 'lodash/omit';

export const getUserInfo = () =>
  request({
    url: '/user/info',
    method: 'get',
  });

export const login = (data: any) =>
  request({
    url: '/user/login',
    method: 'post',
    data,
  });

export const jAccount = (data: { code: string; redirectUrl: string }) =>
  request({
    url: `/user/jaccount/code`,
    method: 'get',
    params: data,
  });

export const getUserList = () =>
  request({
    url: '/user',
    method: 'get',
  }) as AxiosPromise<IUser[]>;

export const createUser = (data: { username: string; password: string; role: Role }) =>
  request({
    url: '/user/create',
    method: 'post',
    data,
  }) as AxiosPromise<{ message: string }>;

export const removeUser = (id: string) =>
  request({
    url: `/user/${id}`,
    method: 'delete',
  }) as AxiosPromise<{ message: string }>;

export const editUser = (data: IUserEdit) =>
  request({
    url: `/user/${data.id}`,
    method: 'put',
    data: _omit(data, 'id'),
  }) as AxiosPromise<{ message: string }>;
